import { useEffect, type ReactNode } from "react";

/**
 * The mockup's sheet: slides up from the bottom on a phone, a right-hand
 * panel from 720px up. Closes on Escape and on a tap on the scrim, never on
 * a tap inside the panel.
 */
export function Sheet({ title, label, onClose, children }: { title?: ReactNode; label: string; onClose: () => void; children: ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="scrim"
      data-testid="sheet-scrim"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="sheet" role="dialog" aria-modal="true" aria-label={label}>
        <div className="grab" />
        <div className="sheet-h">
          {title ? <h2>{title}</h2> : null}
          <button type="button" className="icon-btn x" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
